/**
 * My Tickets rows open their ticket (14 Oct, user feedback via Rusty: people
 * did not realise a ticket could be clicked).
 *
 * The whole row is the target: a click anywhere on it opens the ticket, like
 * its own link, unless the click was meant for something else in the row (a
 * link, a button, the requests expander), the reader is selecting text, or
 * asks for a new tab (Ctrl / Cmd / Shift / middle button: the row's own link
 * does that). The row the reader opened last is the grid's current row when
 * they come back. Pure, so `tests/row-open.test.mjs` runs it without React.
 */

/** Elements inside a row that take their own clicks. */
export const ROW_CONTROLS =
  "a,button,summary,details,input,select,textarea,label,[role='button'],[role='link']";

/** The attribute on a row's main link, the one a click on the row follows. */
export const ROW_LINK_ATTRIBUTE = "data-row-link";

/** Where the last opened row is remembered for the session. */
export const LAST_OPENED_KEY = "tickets.lastOpenedRow";

export interface RowClick {
  /** 0 is the main button. */
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  /** The click landed on (or inside) a control of its own. */
  onControl: boolean;
  /** Text is selected (the reader is copying, not opening). */
  selecting: boolean;
}

/** Whether a click on a row's background opens the row's ticket. */
export function opensRow(click: RowClick): boolean {
  return (
    click.button === 0 &&
    !click.metaKey &&
    !click.ctrlKey &&
    !click.shiftKey &&
    !click.altKey &&
    !click.onControl &&
    !click.selecting
  );
}

/** The remembered row, if it is on this page; else none. */
export function currentRowFor(stored: string | null, rowIds: readonly string[]): string | null {
  return stored !== null && rowIds.includes(stored) ? stored : null;
}
